import React, { FC, ReactNode, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { getIsSignedIn, getStoreRef, getRoles, getIsAdmin } from 'reducks/auth/selectors'
import { fetchSwitchingStoreRefs, fetchAdminSwitchingStoreRefs, listenAuthState } from 'reducks/auth/operations'
import { fetchStore } from 'reducks/store/operations'
import { fetchSpecialHolidays } from 'reducks/calendar/operations'
import { fetchStoreTimesale } from 'reducks/storeTimesale/operations'
import { UNAUTHORIZED_URLS } from 'constants/auth'

type Props = {
  children: ReactNode
}

const Auth: FC<Props> = (props) => {
  const { children } = props
  // 認証状態を取得
  const dispatch = useDispatch()
  const isAdmin = useSelector((state: State) => getIsAdmin(state))
  const isSignedIn = useSelector((state: State) => getIsSignedIn(state))
  const roles = useSelector((state: State) => getRoles(state))
  const storeRef = useSelector((state: State) => getStoreRef(state))
  const path = useSelector((state: State) => state.router.location.pathname)

  useEffect(() => {
    // ログインしたら祝日情報を取得、認証状態でなければ認証の確認
    if (isSignedIn) {
      dispatch(fetchSpecialHolidays())
    } else {
      dispatch(listenAuthState())
    }
  }, [isSignedIn])

  // 認証が完了してstore_refが取得できたら、ストア情報と祝日の情報を取得
  useEffect(() => {
    if (!storeRef) return
    dispatch(fetchStore(storeRef))
  }, [storeRef])

  useEffect(() => {
    if (roles.length === 0) return
    dispatch(fetchSwitchingStoreRefs(roles))
  }, [roles])

  useEffect(() => {
    if (!isAdmin || !storeRef) return
    dispatch(fetchAdminSwitchingStoreRefs(storeRef))
  }, [isAdmin, storeRef])

  // セール情報を取得
  useEffect(() => {
    if (!storeRef) return
    dispatch(fetchStoreTimesale(storeRef))
  }, [storeRef])

  // 認証済み、または認証が必要のないページであれば表示
  if (isSignedIn || UNAUTHORIZED_URLS.includes(path)) {
    return <>{children}</>
  } else {
    return <></>
  }
}

export default Auth
